export enum ModulesNotDevelopedYet {
	genetic = 'genetic',
	admin = 'admin',
	reproduction = 'reproduction',
}
